import React, { useContext } from "react";
import EditModal from "../../profiles/EditModal";
import { ExpertContext } from "../data/expert_context_management";
import CompaniesModalBody from "./companies_modal_body";
import EmploymentModalBody from "./employment_modal_body";
import ExpertsModalBody from "./experts_modal_body";
import HeaderModalBody from "./header_modal_body";
import ProductsModalBody from "./products_modal_body";

// Expert's edit modal: consumes the shared <EditModal> shell (chrome only) and keeps the
// engine-specific section -> body mapping + title here (mirrors pr_profiles/edit/edit_modal.jsx).
// The body owns its own <Modal.Body>/<Modal.Footer> (the shell renders children raw).
function ExpertEditModal() {
  const { expert, openEditModal, setOpenEditModal, setGeneralError } = useContext(ExpertContext);

  const closeModal = () => {
    setOpenEditModal(null);
    setGeneralError(null);
  };

  const sectionLabel = () => {
    switch (openEditModal) {
      case "HEADER":
        return " - Header Details";
      case "EMPLOYMENT":
        return " - Employment";
      case "EXPERTS":
        return " - Add Represented Expert";
      case "PRODUCTS":
        return " - Add Represented Product";
      case "COMPANIES":
        return " - Add Represented Company";
      default:
        return null;
    }
  };

  const body = () => {
    // The body reads the loaded expert + its plumbing (expertId, silentReload, setGeneralError, ...)
    // from ExpertContext; it takes only `close` as a prop.
    switch (openEditModal) {
      case "HEADER":
        return <HeaderModalBody close={closeModal} />;
      case "EMPLOYMENT":
        return <EmploymentModalBody close={closeModal} />;
      case "EXPERTS":
        return <ExpertsModalBody close={closeModal} />;
      case "PRODUCTS":
        return <ProductsModalBody close={closeModal} />;
      case "COMPANIES":
        return <CompaniesModalBody close={closeModal} />;
      default:
        return null;
    }
  };

  return (
    <EditModal
      show={!!openEditModal}
      onClose={closeModal}
      fullscreen="lg-down"
      title={
        <>
          Editing {expert?.name}
          {sectionLabel()}
        </>
      }
    >
      {body()}
    </EditModal>
  );
}

export default ExpertEditModal;
